import PropTypes from 'prop-types';
import {
  Alert,
  Box,
  Button,
  Footer,
  GridedContent,
  IconWarningOutline,
} from '@capitalise/ui-design-system';
import { useSearchClientContext } from '../../hooks/useSearchClientContext';
import styled from 'styled-components';

const FullWidthGridedContent = styled(GridedContent)`
  width: 100%;
`;

const SearchClientFooter = ({
  handleOnClick,
  handlePurchaseCreditsClick,
  skipDisable,
  showPurchaseCredits,
}) => {
  const { selectedCompanies, archivedCompanies, existingCompanies, maxMonitorClients, isLoading } =
    useSearchClientContext();
  const monitorClientsCount = Number(selectedCompanies.length) + Number(existingCompanies.length);
  const isOverLimit = maxMonitorClients !== null && maxMonitorClients < monitorClientsCount;
  const isDisabled =
    maxMonitorClients !== null &&
    ((selectedCompanies.length === 0 && archivedCompanies.length === 0 && !skipDisable) ||
      isOverLimit);

  const NoPaddingFooter = styled(Footer)`
    padding: 0;
    height: ${isOverLimit ? 'auto' : '80px'};
  `;

  const label = showPurchaseCredits
    ? `${monitorClientsCount} companies added. Purchase more credits to add all companies.`
    : `${monitorClientsCount} companies added. After completing the onboarding you can purchase more credits.`;

  return (
    <NoPaddingFooter padding={0} data-testid="SearchClientFooter">
      <FullWidthGridedContent>
        <Box
          width="100%"
          gridColumn={{ _: '1/5', sm: '3/7', lg: '5/9' }}
          py={isOverLimit ? '3xsmall' : '0'}
        >
          {isOverLimit && (
            <Alert
              onActionClick={showPurchaseCredits ? handlePurchaseCreditsClick : null}
              icon={IconWarningOutline}
              type="warning"
              actionLabel={showPurchaseCredits ? 'Purchase clients' : null}
              wrapperProps={{ mb: '3xsmall' }}
            >
              {label}
            </Alert>
          )}
          <Button
            baseColor="green"
            fullWidth
            disabled={isDisabled}
            onClick={handleOnClick}
            loading={isLoading}
            data-testid={`add-clients-add-button`}
          >
            {`Monitor ${monitorClientsCount} client${monitorClientsCount === 1 ? '' : 's'}`}
          </Button>
        </Box>
      </FullWidthGridedContent>
    </NoPaddingFooter>
  );
};

SearchClientFooter.propTypes = {
  handleOnClick: PropTypes.func,
  handlePurchaseCreditsClick: PropTypes.func,
  maxMonitorClients: PropTypes.number,
  skipDisable: PropTypes.bool.isRequired,
  showPurchaseCredits: PropTypes.bool,
};

SearchClientFooter.defaultProps = {
  showPurchaseCredits: true,
};

export default SearchClientFooter;
